<template>
	<div class="m-portlet m-portlet--mobile m-portlet-incr-com">
		<div class="m-portlet__head row action-tools">
			<div class="col-2">
				<div class="input-group">
					<select id="filterChannelSelection" class="form-control">
					</select>
				</div>
			</div>
			<div class="col-5">
				<div class="form-group m--margin-top-10">
					<div class="m-checkbox-inline">
						<label class="m-checkbox">
							<input type="checkbox" value="2d" v-model="propFilter"> 2D
							<span></span>
						</label>
						<label class="m-checkbox">
							<input type="checkbox" value="3d" v-model="propFilter"> 3D
							<span></span>
						</label>
						<label class="m-checkbox">
							<input type="checkbox" value="4d" v-model="propFilter"> 4D
							<span></span>
						</label>
						<label class="m-checkbox">
							<input type="checkbox" value="da" v-model="propFilter"> Đá
							<span></span>
						</label>
					</div>
				</div>
			</div>
			<div class="col-5">
				<div class="input-group">
					<div class="input-group-prepend">
						<span class="input-group-text">Tìm:</span>
					</div>
					<input id="number_search" v-model="numberSearch" type="text" class="form-control m-input" placeholder="Nhập số">
				</div>
			</div>
		</div>
		<div class="m-portlet__body row table-content">
			<div class="col-6 col-sm-6 col-md-6 col-lg-4 col-xl-4" v-if="propFilter.indexOf('2d') >= 0">
				<commission-table 
					title="2D" 
					type="2d" 
					:currentGame="currentGame" 
					:comms="comms['2d']"
					:dataKey="{parent: 'parentIncr', child: 'childIncr', user: 'userIncr', data: 'incrValue'}"
					v-on:number-add-click="onAddOrUpdateCommission"
				></commission-table>
			</div>
			<div class="col-6 col-sm-6 col-md-6 col-lg-4 col-xl-4" v-if="propFilter.indexOf('3d') >= 0">
				<commission-table 
					title="3D" 
					type="3d" 
					:currentGame="currentGame" 
					:comms="comms['3d']"
					:dataKey="{parent: 'parentIncr', child: 'childIncr', user: 'userIncr', data: 'incrValue'}"
					v-on:number-add-click="onAddOrUpdateCommission"
				></commission-table>
			</div>
			<div class="col-6 col-sm-6 col-md-6 col-lg-2 col-xl-2" v-if="propFilter.indexOf('4d') >= 0">
				<commission-table 
					title="4D" 
					type="4d" 
					:currentGame="currentGame" 
					:comms="comms['4d']"
					:dataKey="{parent: 'parentIncr', child: 'childIncr', user: 'userIncr', data: 'incrValue'}"
					v-on:number-add-click="onAddOrUpdateCommission"
				></commission-table>
			</div>
			<div class="col-6 col-sm-6 col-md-6 col-lg-2 col-xl-2" v-if="propFilter.indexOf('da') >= 0">
				<commission-table 
					title="Đá" 
					type="da" 
					:currentGame="currentGame" 
					:comms="comms['da']"
					:dataKey="{parent: 'parentIncr', child: 'childIncr', user: 'userIncr', data: 'incrValue'}"
					v-on:number-add-click="onAddOrUpdateCommission"
				></commission-table>
			</div>
		</div>
	</div>
</template>

<script>
	import moment from 'moment';
	import { mapGetters } from 'vuex';
	import GameInfoSelection from './GameInfoSelection';
	import NumberTable from '../NumberTable';
	import groupBy from 'lodash/groupBy';
	import sortBy from 'lodash/sortBy';
	import { Utilities } from '../../utilities';

	export default {
		data(){
			let vm = this;

	        return {
	        	"originComs": [],
	        	"comms": { "2d":[], "3d":[], "4d":[], "da":[] },
				"currentGame": "1",
				"propFilter": ["2d", "3d", "4d", "da"],
				"channelsToday": [],
				"numberSearch": "",

	            "today": moment().format('DD/MM/Y'),
	        }
	    },

	    mounted(){
	    	this.initScript();
	    	let channelsToday = this.getchannelsToday();
	    	$("#filterChannelSelection").select2({data: channelsToday, width:"100%"});
	    },

	    watch:{
	    	originComs: function(comms){
	    		this.comms = this.groupCommByProp(comms);
	    		if($("#filterChannelSelection").val() == ""){
	    			$("#filterChannelSelection").val(parseInt($("#filterChannelSelection option:eq(0)").val())).trigger('change.select2');
	    		}else{
	    			$("#filterChannelSelection").trigger('change.select2');
	    		}
	    	},
	    	numberSearch: function(n){
	    		this.filterByNumber(n);
	    	},
	    	// displayTangCoForm: async function(display){
	    	// 	if(!display) return;
	    	// 	await this.$nextTick(); // wait for DOM to update

	    	// 	let vm = this;
	    	// }
	    },

	    components: {
        	'game-info-selection': GameInfoSelection,
        	'commission-table': NumberTable
        },

	    created(){
    		this.getIncrCommission();
    	},

    	computed: {
			...mapGetters({
				user: 'user',
		  		gameInfo: 'gameInfo'
			})
		},

	    methods: {
	    	initScript: function(){
	    		let vm = this;

				$("#filterChannelSelection").on("change.select2", function(e){
					if(!$(this).select2('data')[0]) return;

					let game = $(this).select2('data')[0].gameId;
					let channel = $(this).val();
					vm.currentGame = parseInt(game);
					let data = vm.originComs.filter(function(el){
						let elc = el.channel.split(".");
						return elc.includes(channel);
					});
					vm.comms = vm.groupCommByProp(data);
				});
	    	},

	    	getchannelsToday: function() {
	    		let vm = this;
				let ccc = [];
				for(let game in this.gameInfo.channelToday){
					if(game == 3) continue;

					let cs = this.gameInfo.channelToday[game].map((el) => {
        				return { id: el.channel_id, text: vm.gameInfo.channels[parseInt(el.channel_id)].alias, gameId: game };
        			});

        			ccc = ccc.concat(cs);
				}

				return ccc;
			},

	    	groupCommByProp: function(comms){
	    		let commission = {};
	    		let vm = this;

	    		comms = groupBy(comms, function(val){
	    			return Utilities.propGroupToName(val.prop);
	    		});

	    		for(let prop in comms){
	    			if(!commission[prop]) commission[prop] = [];

	    			let gcns = groupBy(comms[prop], function(val){ return val.game+"_"+val.channel+"_"+val.number; });
	    			for(let gcn in gcns){
	    				let number = gcn.split("_")[2];
	    				let propComm = groupBy(gcns[gcn], function(val){ return val.prop; });

    					commission[prop].push({
		    				"number": number,
		    				"comm": propComm
		    			});
	    			}
	    		}

	    		for(let prop in commission){
	    			let arr = sortBy(commission[prop], function(o) { return o.number; })
	    			commission[prop] = arr;
	    		}

	    		return commission;
	    	},

	        getIncrCommission: function(){
	        	let vm = this;

	        	window.axios.get("admin-panel/tools/commission")
	        				.then((res) => {
	        					res = res.data;
	        					vm.originComs = res.data;
	        				})
	        				.catch((error) => {

	        				});
	        },

	        filterByNumber: function(val){
	        	let vm = this;
	        	let channel = $("#filterChannelSelection").val();

	        	let filterd = this.originComs.filter(function(el){
	        		let elc = el.channel.split(".");
					return elc.includes(channel);
	        	});

	        	if(val == "") {
					vm.comms = vm.groupCommByProp(filterd);
	        		return;
	        	}

	        	filterd = filterd.filter(function(el){
	        		if(el.number.includes(".")){
	        			return el.number.includes(val);
	        		}

	        		return el.number == val;
	        	});

	        	vm.comms = vm.groupCommByProp(filterd);
	        },

	        onAddOrUpdateCommission: function({data, callback}){
	        	let vm = this;
	        	axios.post("admin-panel/tools/commission", { "commission": data })
				    .then((response) => {
				    	if(response.data.code == 0){
				    		swal("", "Tăng cò thành công", "success");
				    		callback();
				    		vm.getIncrCommission();
				    	}
				    })
				    .catch((error) => { });
	        }
	    }
	}

</script>

<style>
	.m-portlet-incr-com .action-tools{
		padding: 10px 0px;
	    border-bottom: 1px dashed #ebedf2;
	}
	.m-portlet-incr-com .table-content{
		padding-top: 10px;
	}
	.m-portlet-incr-com .table{
		text-align: center;
	}
	.m-portlet-incr-com.m-portlet {
	    margin-bottom: 6rem;
	}
	.commission .m-portlet__head-caption{
		margin-top: 13px;
	}
</style>